class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Trash button in the product row (the row is re-rendered on every add, so delegate).
    this.notification.addEventListener('click', (evt) => {
      const remove = evt.target.closest('[data-cn-remove]');
      if (remove) this.removeItem(remove);
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!target || !html) return;
      target.innerHTML = this.getSectionInnerHTML(html, section.selector, section.outer);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  // Remove the line that was just added, update the count, then close.
  removeItem(button) {
    const key = button.dataset.cnRemove;
    if (!key || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const sections = ['cart-notification-button', 'hive-cart-icon-bubble'];
    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections, sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        sections.forEach((id) => {
          const target = document.getElementById(id);
          const html = state.sections && state.sections[id];
          if (target && html) target.innerHTML = this.getSectionInnerHTML(html);
        });
        const product = document.getElementById('cart-notification-product');
        if (product) product.innerHTML = '<p class="hive-cn__removed" role="status">Removed from your cart</p>';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-notification', cartData: state });
        }
        setTimeout(() => this.close(), 1400);
      })
      .catch(() => {
        button.removeAttribute('aria-busy');
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        outer: true, // keep the row wrapper, it carries the layout
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'hive-cart-icon-bubble', // Keep for hive bubble
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', outer = false) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!el) return '';
    return outer ? el.outerHTML : el.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    // composedPath() is fixed when the click starts, so clicks on content that gets
    // re-rendered during the click (e.g. the trash button) still count as inside.
    const inside = typeof evt.composedPath === 'function' ? evt.composedPath().includes(this) : !!target.closest('cart-notification');
    if (target !== this.notification && !inside) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
